export default __webpack_public_path__ + "static/media/plane-seat11.efd38030.svg";